import { xBaseTheme } from "@eisinc/XDL/types";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

export default {
    defaultProps: {
        color: "primary",
        border: "rectangle",
        typographyProps: {},
        sizeVariant: "default",
        labelProps: {
            color: getColor("text.main"),
            size: 14,
            css: css`
                font-weight: 600;
                letter-spacing: 0.3px;
                line-height: 18px;
                min-height: 14px;
            `,
        },
        errorProps: {},
        css: css``,

        cssOverrides: {
            formInputWrapper: css`
                margin-top: 7px !important;

                input,
                select,
                textarea {
                    &:disabled {
                        opacity: 0.5;
                        background: ${getColor("common.white")} !important;
                        color: inherit !important;
                    }
                }
            `,
            descriptionWrapper: css`
                margin-top: 5px !important;

                * {
                    font-size: 14px;
                    font-weight: 600;
                    line-height: 17px;
                    letter-spacing: 0.3px;
                }

                > * {
                    &:first-child {
                        &:before {
                            content: "*";
                        }
                    }
                }
            `,
            formField: css`
                label[disabled] {
                    opacity: 0.5;
                }
            `,
        },
    },
} as xBaseTheme["fieldSet"];
